var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('h3',[_vm._v(_vm._s(_vm.date))]),_vm._l((_vm.body.split('\n')),function(para,i){return [_c('p',{key:i},[_vm._v(_vm._s(para))])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }